import { useLocalization } from '@progress/kendo-react-intl';
import alert from '../../assets/alert_synchro.png';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { AccessToken } from '../../config/AccessToken';
import { setData } from '@progress/kendo-intl';

export const Efficiency = () => {

    const SERVER_URL = process.env.REACT_APP_SERVER_URL;

    const [error, setError] = useState(false);
    const [data, setData] = useState<any>([]);

    const localizationService = useLocalization();
    const [instance, accessTokenRequest] = AccessToken();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        let languageId = localStorage.getItem('languageId');

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                const res = await axios.get(`${SERVER_URL}/synchro/GetEfficiency`, { headers })
                const data = res.data.data

                setData(data)
                if(data.missions == 0){
                    setError(true)
                }
                //averageMissionLength, efficiency, missions


            } catch (error: any) {
                setError(error);
            }
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    return (
        <div>
            {error && (
                <>
                    <img src={alert} alt="Warning" /> 
                    <div style={{color:'#838393'}}>{localizationService.toLanguageString('synchro.no_missions', 'NOT_FOUND')}</div>
                </>
            )}
            {!error && data && (
                data.forEach((item: any) => {
                    <>    
                        {/*<KpiStatus level={data.efficiency > 1.5 ? 'low' : data.efficiency > 0.9 ? 'medium' : 'high'}>
                            Durata media: {Number(data.averageMissionLength).toFixed(1)} [s] <br></br>
                            Missioni/Ora: {(Number(data.missions)/2).toFixed(1)}
                        </KpiStatus>*/}
                        {localizationService.toLanguageString('synchro.average_duration', 'NOT_FOUND')}: {Number(item.averageMissionLength).toFixed(1)} [s] <br></br>
                        {localizationService.toLanguageString('synchro.missions_hour', 'NOT_FOUND')}: {(Number(item.missions)/2).toFixed(1)}
                    </>               
                })
            )}
        </div>
    )
}